import { useState, useRef } from 'react';

// @Utility
import { setStorage } from "../../../../../../../@utility/app/storage";
import alertText from "../../../../../../../@utility/app/alertText";

// Redux & Action
import { useDispatch } from 'react-redux';
import { setDataAlert } from "../../../../../../../@core/redux/actions/app/alert";
import { setStatusSpinner } from "../../../../../../../@core/redux/actions/app/spinner";
import { setDepositData } from "../../../../../../../@core/redux/actions/deposit/index";

// Component
import { Grid } from '@material-ui/core';

// Services Request
import { apiServices } from "../../../../../../../@core/services/apiReqService";
import { loadDepositFirst } from "../../../../../../../@core/services/depositService";

// Icon
import UploadFileIcon from '@material-ui/icons/AttachFile';
import UploadIcon from '@material-ui/icons/Publish';

// Style & CSS
import buttonStyles from './../../../../assets/css/Button.module.css';

export default function FormSlipChannel({ depositItems, onShow }) {
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);

    const [imageUpload, setImageUpload] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const openBox = (snackbarJson) => {
        dispatch(setDataAlert({
            type: snackbarJson.statusAlert,
            title: snackbarJson.titleAlert,
            text: snackbarJson.textAlert,
            action: true,
            redirect: null,
            show: true,
            buttonText: "ตกลง"
        }));
    };

    const reloadData = () => {
        loadDepositFirst().then((data) => {
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                if (data?.result?.pay_src) {
                    setStorage("paySrc", data?.result?.pay_src);
                }

                if (data?.result?.pay_mode) {
                    setStorage("payMode", data?.result?.pay_mode);
                }

                if (data?.result?.pay_account?.account) {
                    setStorage("payAccount", JSON.stringify(data?.result?.pay_account));
                }

                if (data?.result?.pay_amount) {
                    setStorage("payAmount", data?.result?.pay_amount);
                }

                if (data?.result?.pay_time_out) {
                    setStorage("payTimeOut", data?.result?.pay_time_out);
                }

                dispatch(setDepositData(data.result));
                setStorage("processDeposit", data.result.id);
            }
        });
    };

    const confirmPaySlipChannel = (data, setImageUpload, setImagePreview) => {
        apiServices(data, "file", "/customer/payment-v2/deposit/slip").then((data) => {
            const { code: statusCode, message } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                reloadData();

                dispatch(setDataAlert({
                    type: "success",
                    title: "แจ้งเตือน",
                    text: "แนบรูปสลิปสำเร็จ !",
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));

                if (onShow) {
                    onShow();
                }
            }
            else {
                if (setImageUpload) {
                    setImageUpload(null);
                }

                if (setImagePreview) {
                    setImagePreview(null);
                }

                if (statusCode === 99) {
                    dispatch(setDataAlert({
                        type: "warning",
                        title: "แจ้งเตือน",
                        text: message,
                        action: true,
                        redirect: null,
                        show: true,
                        buttonText: "ตกลง"
                    }));
                }
                else {
                    let snackbarJson = alertText(statusCode);
                    dispatch(setDataAlert({
                        type: snackbarJson.statusAlert,
                        title: snackbarJson.titleAlert,
                        text: snackbarJson.textAlert,
                        action: true,
                        redirect: null,
                        show: true,
                        buttonText: "ตกลง"
                    }));
                }
            }
        });
    };

    const onImageChange = (e) => {
        let imageData = e.target.files;
        if (imageData.length > 0) {
            const file = imageData[0];
            if (file.type === "image/png" || file.type === "image/jpeg" || file.type === "image/jpg") {
                setImageUpload(file);
                setImagePreview(URL.createObjectURL(file));
            } else {
                openBox({
                    statusAlert: "warning",
                    titleAlert: "แจ้งเตือน",
                    textAlert: "ไฟล์รูปภาพไม่ถูกต้อง กรุณาเลือกรูปภาพใหม่อีกครั้ง !"
                });
                setImageUpload(null);
                setImagePreview(null);
            }
        } else {
            setImageUpload(null);
            setImagePreview(null);
        }
    };

    const confirmUploadSlip = () => {
        if (!imageUpload) return null;

        const dataUpload = new FormData();
        dataUpload.append('slip', imageUpload);
        dataUpload.append('td_date', depositItems?.time_create);
        dataUpload.append('td_id', depositItems?.id);

        dispatch(setStatusSpinner({ status: true, textProcess: null }));
        confirmPaySlipChannel(dataUpload, setImageUpload, setImagePreview)
    };

    const renderContent = () => {
        return (
            <div className="center">
                <div onClick={() => fileInputRef.current && fileInputRef.current.click()}>

                    {
                        imagePreview ?
                            (
                                <img
                                    src={imagePreview}
                                    alt="preview"
                                    className="imageSlipPreview"
                                />
                            )
                            :
                            (
                                <div className="depositSlip">
                                    <Grid
                                        className="cursorPointer"
                                        container
                                        alignItems="center"
                                        justifyContent="center"

                                    >
                                        <Grid item>
                                            <UploadFileIcon className="iconSlipImageUploadSize" />
                                        </Grid>
                                        <Grid item>
                                            <div className="file-upload-wrapper02" data-text={"แนบสลิป"}>
                                                <input
                                                    ref={fileInputRef}
                                                    name="file-upload-field"
                                                    type="file"
                                                    className="file-upload-field"
                                                    onChange={onImageChange}
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    style={{ display: "none" }}
                                                />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            )
                    }
                </div>

                {
                    imageUpload && (
                        <div className="contentMarginTop03 center">
                            <button
                                className={buttonStyles.btnConfirmSlip}
                                style={{
                                    opacity: imageUpload ? "1" : "0.5",
                                    cursor: imageUpload ? "pointer" : "no-drop"
                                }}
                                onClick={confirmUploadSlip}
                            >
                                <Grid container alignItems="center" justifyContent="center" spacing={2}>
                                    <Grid item>
                                        <UploadIcon className="iconTransactionaction" />
                                    </Grid>
                                    <Grid item>
                                        อัพโหลดสลิป
                                    </Grid>
                                </Grid>
                            </button>
                        </div>
                    )
                }

            </div>
        );
    };

    return (
        <div className="contentBoxMarginTop">
            {renderContent()}
        </div>
    );
}
